import { RgsObject } from './rgs-object.model';

export interface RgsObjectCompleteListWithOptionsDTO {
  data: RgsObject[];
  options: {
    [key: string]: string[];
  };
}

export class RgsObjectCompleteListWithOptions {
  public data: RgsObject[];
  public options: Map<string, Set<string>>;

  constructor(dto: RgsObjectCompleteListWithOptionsDTO) {
    const characteristicsMap = new Map<string, Set<string>>();
    Object.entries(dto.options).forEach(([key, value]) => {
      characteristicsMap.set(key, new Set(value));
    });

    this.data = dto.data;
    this.options = characteristicsMap;
  }
}
